import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, GiftIcon, FileTextIcon, ClockIcon, GlobeIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
const miniBadges = [{
  icon: BookOpenIcon,
  label: '6 tomos'
}, {
  icon: GiftIcon,
  label: '5 bonos pro'
}, {
  icon: FileTextIcon,
  label: '300 páginas'
}, {
  icon: ClockIcon,
  label: 'Minuto a minuto del día del evento'
}, {
  icon: GlobeIcon,
  label: 'Funciona en cualquier país hispano'
}];
export function Hero() {
  return <section className="w-full bg-ivory pb-16 pt-14 md:pb-24 md:pt-20" data-id="element-124" data-mp="xbfkjamqpf5n">
      <div className="mx-auto w-full max-w-content px-5 sm:px-8" data-id="element-125" data-mp="sb1c3rh88373">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        ease: [0.22, 1, 0.36, 1]
      }} className="flex flex-col items-center text-center" data-id="element-126" data-mp="sde0onhhpbt4">
          <p className="kicker" data-id="element-127" data-mp="381xiwrlewq70">
            ◆ Sistema Master Plan 15 — Ingeniería de eventos en 6 tomos
          </p>

          <h1 className="mt-6 max-w-[20ch] font-serif text-[34px] leading-[1.1] tracking-[-0.01em] sm:text-5xl md:text-[56px]" data-id="element-128" data-mp="3j9k7h1pgwzbd">
            Dirige cada fiesta de 15 como la planner que pone el precio.
            <span className="mt-3 block font-serif text-[22px] italic text-ink-soft sm:text-3xl md:text-[32px]" data-id="element-129" data-mp="399jm7a81g94j">
              No la que lo baja.
            </span>
          </h1>

          <p className="measure mt-7 text-[15px] leading-relaxed text-ink-soft sm:text-base" data-id="element-130" data-mp="30hrfnam4xk58">
            El sistema operativo completo en 6 tomos para organizadoras de
            quince años: 300 páginas de estructuras de costos, contratos,
            cronogramas técnicos y guiones de venta. Desde la primera reunión
            con los papás hasta el minuto a minuto del día del evento y las
            clientas que llegan solas por recomendación.
          </p>
        </motion.div>

        <motion.figure initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.7,
        delay: 0.12,
        ease: [0.22, 1, 0.36, 1]
      }} className="mx-auto mt-12 max-w-[880px]" data-id="element-131" data-mp="2lla6mq1f4hlu">
          <img src="https://cdn.magicpatterns.com/patterns/generated-images/084b4e94-3b7d-4367-959d-66b233a7bba6.jpg" alt="Los 6 tomos impresos del Master Plan 15 apilados sobre una mesa de trabajo con una paleta de colores, un moodboard y una lapicera dorada." className="w-full rounded-card border border-gold-line object-cover shadow-card" loading="eager" data-id="element-132" data-mp="na094yrvn3e6" />
        </motion.figure>

        <ul className="mt-10 flex flex-wrap items-center justify-center gap-x-6 gap-y-3" data-id="element-133" data-mp="112g6pk20e97p">
          {miniBadges.map(({
          icon: Icon,
          label
        }) => <li key={label} className="flex items-center gap-2 text-[13px] text-ink-soft" data-id="element-134" data-mp="x0l3ga0iplra">
              <Icon className="h-4 w-4 text-gold" aria-hidden="true" data-id="element-135" data-mp="3lqm4i498ffxk" />
              {label}
            </li>)}
        </ul>

        <div className="mt-10 flex justify-center" data-id="element-136" data-mp="1xa429a5swchi">
          <CtaButton size="xl" data-id="element-137" data-mp="1x7869rdijxvp">
            Quiero el Master Plan 15 — Acceso inmediato
          </CtaButton>
        </div>

        <div className="rule-gold mt-16 md:mt-20" aria-hidden="true" data-id="element-138" data-mp="26a9atnmqdgx9" />
      </div>
    </section>;
}